import { auth, db } from "./firebase";
import { collection, doc, setDoc } from "firebase/firestore";
import { ErrorWithDetails } from "../utility/error-handling/error-handling-utility";

enum inviteStatus {
    unused = 'unused',
    accepted = 'accepted',
    declined = 'declined'
}

interface CreateInviteVars {
    email: string;
}

export const firebaseCreateInvite = async (vars: CreateInviteVars) => {
    /**
     * Create new invite
     */
    if (!auth.currentUser) {
        console.log('No user logged in')
        return
    }

    const { email } = vars

    // Get document reference for new document with auto-generated unique ID.
    const inviteDoc = doc(collection(db, "invites"))

    // Create document
    try {
        await setDoc(inviteDoc, {
            inviter: auth.currentUser.uid,
            invitedMail: email,
            // use enum type
            status: inviteStatus.unused,
        });
        return {
            success: true,
            message: `${email} wurde zu dreico eingeladen`,
        }
    } catch (e) {
        return {
            success: false,
            message: new ErrorWithDetails(e, 'Error beim Einladen von ' + email),
        }
    }
}